import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "healing"
const HealingIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12.795 14.386 11.735 15.446 10.674 14.386 11.734 13.326zM10.674 12.265 9.614 13.325 8.551 12.265 9.613 11.205zM15.447 11.735 14.386 12.795 13.326 11.735 14.385 10.674zM13.325 9.613 12.265 10.674 11.205 9.614 12.264 8.552z" />
          <path
            fillRule="evenodd"
            d="M14.917 2.189C15.503 1.603 16.452 1.603 17.038 2.189L21.811 6.962C22.397 7.548 22.397 8.497 21.811 9.083L18.894 12 21.81 14.917C22.397 15.503 22.397 16.453 21.811 17.039L17.04 21.81C16.453 22.397 15.503 22.397 14.917 21.811L12 18.894 9.083 21.81C8.497 22.397 7.548 22.397 6.963 21.811L2.188 17.038C1.603 16.452 1.603 15.503 2.189 14.917L5.105 12 2.19 9.083C1.603 8.497 1.603 7.548 2.189 6.962L6.962 2.189C7.548 1.603 8.497 1.603 9.083 2.189L12 5.105zM3.249 15.977 8.023 20.751 20.75 8.023 15.977 3.249zM13.06 17.833 15.977 20.751 20.751 15.977 17.833 13.06zM3.25 8.023 6.167 10.939 10.939 6.167 8.023 3.25z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default HealingIcon
